import React from 'react';
import { UserCog, X } from 'lucide-react';
import { toast } from 'sonner';

export function ImpersonationBanner() {
  const [isImpersonating, setIsImpersonating] = React.useState(false);
  const [originalAdmin, setOriginalAdmin] = React.useState(null);
  const [currentUserName, setCurrentUserName] = React.useState('');
  const [currentUserRole, setCurrentUserRole] = React.useState('');

  React.useEffect(() => {
    // Check if we're in impersonation mode
    const impersonating = localStorage.getItem('is_impersonating') === 'true';
    setIsImpersonating(impersonating);
    
    if (impersonating) {
      try {
        const adminData = localStorage.getItem('original_admin_user');
        if (adminData) {
          setOriginalAdmin(JSON.parse(adminData));
        }
        
        // Get current user info from the stored user object
        const userData = localStorage.getItem('user');
        if (userData) {
          const user = JSON.parse(userData);
          setCurrentUserName(user.name || 'User');
          setCurrentUserRole(user.role_name || '');
        }
      } catch (e) {
        console.error('Error parsing impersonation data:', e);
      }
    }
  }, []);

  const handleStopImpersonation = () => {
    try {
      // Restore original admin token
      const originalToken = localStorage.getItem('original_admin_token');
      const originalAdminUser = localStorage.getItem('original_admin_user');
      
      if (originalToken) {
        localStorage.setItem('access_token', originalToken);
        localStorage.setItem('token', originalToken);
      }
      
      if (originalAdminUser) {
        localStorage.setItem('user', originalAdminUser);
      }
      
      // Clear impersonation flags
      localStorage.removeItem('original_admin_token');
      localStorage.removeItem('original_admin_user');
      localStorage.removeItem('is_impersonating');
      
      toast.success('Switched back to admin account');
      
      // Reload to apply original session
      window.location.href = '/';
    } catch (error) {
      console.error('Error stopping impersonation:', error);
      toast.error('Failed to switch back. Please log out and log in again.');
    }
  };

  if (!isImpersonating) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-2 px-4 flex items-center justify-center gap-4 shadow-lg z-[100] relative">
      <div className="flex items-center gap-2">
        <UserCog className="w-5 h-5 animate-pulse" />
        <span className="font-medium">
          Viewing as: <span className="font-bold">{currentUserName}</span>
        </span>
        {currentUserRole && (
          <span className="bg-white/20 px-2 py-0.5 rounded-full text-xs">
            {currentUserRole}
          </span>
        )}
      </div>
      
      <div className="text-sm opacity-90">
        (Original: {originalAdmin?.name || 'Admin'})
      </div>
      
      <button
        onClick={handleStopImpersonation}
        className="flex items-center gap-1 bg-white/20 hover:bg-white/30 px-3 py-1 rounded-lg transition-colors text-sm font-medium"
        data-testid="stop-impersonation-btn"
      >
        <X className="w-4 h-4" />
        Switch Back to Admin
      </button>
    </div>
  );
}

export default ImpersonationBanner;
